<mc-editor-toolbar #toolbar [toolbarControl]="toolbarControl$ | async" (itemClick)="onItemClicked($event)">
</mc-editor-toolbar>